import Glide from "@glidejs/glide"
import * as bl from "basiclightbox"
import { removeClassAll } from "../lib/helpers"
import { activeVimeo, activeYoutube, activePlyr } from "./videoPlayer"

export default {
	init: (el) => {
		let slider
		let controlsSlider
		const thumbs = el.querySelectorAll(".js-thumb-btn")
		const thumbContainers = el.querySelectorAll(".js-thumb-btn-container")
		const controlsLeft = el.querySelector(".js-prev")
		const controlsRight = el.querySelector(".js-next")
		const thumbControls = el.querySelector(".js-arrows")

		initSlider()
		initThumbs()
		initPearCommerce()

		function initSlider() {
			const sliderEl = el.querySelector(".glide")
			slider = new Glide(sliderEl, {
				rewind: false,
			})

			slider.on("run", (direction) => {
				updateThumbs(slider.index)
				activeVimeo && activeVimeo.pause()
				activeYoutube && activeYoutube.pauseVideo()
				activePlyr && activePlyr.pause()
			})

			slider.mount()
		}

		function initThumbs() {
			if (thumbContainers.length > 4) {
				const thumbSliderEl = el.querySelector(".thumbSlide")
				controlsSlider = new Glide(thumbSliderEl, {
					perView: 4,
					bound: true,
					rewind: false,
				})
				controlsSlider.mount()

				controlsLeft.addEventListener("click", (event) => {
					slider.go(`<`)
				})

				controlsRight.addEventListener("click", (event) => {
					slider.go(">")
				})
			} else {
				// thumbControls.style.display = "none"

				controlsLeft.addEventListener("click", (event) => {
					slider.go(`<`)
				})

				controlsRight.addEventListener("click", (event) => {
					slider.go(">")
				})
			}

			thumbs.forEach((thumb) => {
				thumb.addEventListener("click", (event) => {
					const idx = Number(event.currentTarget.dataset.idx)
					updateThumbs(idx)
					slider.go(`=${idx}`)
				})
			})
		}

		function updateThumbs(idx) {
			removeClassAll(thumbContainers, "active")
			thumbContainers[idx].classList.add("active")

			if (idx === thumbContainers.length - 1) {
				controlsRight.disabled = true
			} else {
				controlsRight.disabled = false
			}

			if (idx === 0) {
				controlsLeft.disabled = true
			} else {
				controlsLeft.disabled = false
			}

			if (!controlsSlider) return

			if (idx < thumbContainers.length - 3) {
				controlsSlider.go(`=${idx}`)
			}
		}

		function initPearCommerce() {
			const pearCommerceBtn = el.querySelector(".js-pd-cta")

			pearCommerceBtn &&
				pearCommerceBtn.addEventListener("click", (event) => {
					window.dataLayer.push({
						event: "WhereToBuySubmit",
						findItem:
							event.currentTarget.dataset.layer ||
							"ProductDetailPage",
					})
				})
		}
	},
}
